module.exports = __webpack_public_path__ + "img/contacto.1672a540.svg";